import type { Option } from '@/modules/common/types/option.type.ts';
import { TableId } from '@/modules/common/enums/table-id.enum.ts';

export const CONTRACTOR_TYPES: Option<TableId | 'all'>[] = [
  {
    label: 'common.ui.buttonToggle.options.all',
    code: 'all',
  },
  {
    label: 'common.ui.buttonToggle.options.contractor.group',
    code: TableId.UsersGroups,
  },
  {
    label: 'common.ui.buttonToggle.options.contractor.position',
    code: TableId.Positions,
  },
  {
    label: 'common.ui.buttonToggle.options.contractor.initials',
    code: TableId.Users,
  },
];
